import { Card, CardContent, Grid, Typography, Stack, Tooltip, IconButton } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { FILE_UPLOAD_TYPE, RELATION_TYPE } from "../constant";
import FileStatus from "./FileStatus";
import { includes } from "lodash";

const DetailCard = ({ title, data, details, rows, onSuccess }) => {
  const fileDetails = [
    {
      file_type: FILE_UPLOAD_TYPE.AADHAR,
      download_url: details?.customer_docs?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.AADHAR )?.download_url || '',
      verified: details?.aadhaar_details?.find(aadhaar=> aadhaar.verified === "true" || aadhaar.is_verified_by_karza || aadhaar.verified_online_screenshot) || false
    },
    {
      file_type: FILE_UPLOAD_TYPE.PAN,
      download_url: details?.customer_docs?.find(doc => doc?.doc_type === FILE_UPLOAD_TYPE.PAN)?.download_url || '',
      verified: details?.pan_details?.find(pan=> pan.verified  === "true" || pan.is_verified_by_karza || pan.verified_online_screenshot) || false
    }
  ]

  const uploadFileBody ={
    customer_id: details.customer_id,
    loan_id: details.loan_id,
    relation_id: details.relation_id,
    doc_name: details.name
  }

  return (
    <Card sx={{ p: 3, boxShadow: 3, borderRadius: 2, mt: 2 }}>
      {/* Title */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: 2, borderBottom: 1, borderColor: 'divider', pb: 1 }}
      >
        <Typography variant="h4" sx={{ fontWeight: 'bold', fontFamily: 'sans-serif', color: 'primary.main' }}>
          {title}
        </Typography>
      </Stack>

      <CardContent>
        <Grid container spacing={2} columns={{ xs: 1, sm: 12 }}>
          {data.map((item, index) => (
            <Grid item xs={12} sm={rows} key={index}>
              <Typography variant="body1" sx={{ fontWeight: 'bold', color: 'green' }}>
                {item.name}:
                <span style={{ color: 'black', paddingLeft: '10px', fontWeight: 'normal' }}>
                  {details[item.key] || ''}
                </span>
              </Typography>
            </Grid>
          ))}
        </Grid>

        {/* Remarks (Always in the last row, full width) */}
        {details.remarks && (
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ fontWeight: 'bold', color: 'green' }}>
                Remarks:
                <span style={{ color: 'black', paddingLeft: '10px', fontWeight: 'normal' }}>
                  {details.remarks}
                </span>
              </Typography>
            </Grid>
          </Grid>
        )}
      </CardContent>
      {!includes([RELATION_TYPE.REFERENCE],details?.relation_type) && <Grid container spacing={4} alignItems="center" justifyContent="center">
      {fileDetails.map((item, index) => (
        <Grid item xs={12} sm={6} md={5} key={index}>
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            {/* File Upload & Download Status */}
            <FileStatus label={item.file_type?.toUpperCase()} fileType={item.file_type} downloadUrl={item.download_url} details={uploadFileBody} onSuccess={onSuccess}/>
            {/* Verification Status */}
            <Typography
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              width={220}
              border={1}
              borderColor="divider"
              borderRadius={1}
              padding="8px 12px"
              sx={{
                '& button': {
                  minWidth: 'auto',
                  padding: '4px',
                },
              }}
            >
              <Typography variant="body2" noWrap>
                {item.file_type?.toUpperCase()} VERIFIED
              </Typography>
              <Tooltip title={item.verified ? "Verified" : "Not Verified"}>
                <IconButton>
                  {item?.verified ? <CheckCircleIcon color="success" /> : <CancelIcon color="error" />}
                </IconButton>
              </Tooltip>
            </Typography>
          </div>
        </Grid>
      ))}
    </Grid>}
    </Card>
  );
};

export default DetailCard;
